<template>
<div class="wrapper bg" style="position: relative; " id="wrapper">
  <div class="banner" style="height:6rem;z-index: 0">
    <img src="https://pic.dailyqd.com/2021/1229/banner.png" style="width: 100%">
  </div>
  <div class="article_content">
      <h1 class="title">我是第五届金海星奖<br/> {{ category }}</h1>
      <img :src="img" alt="" class="headImg">
      <div class="name">{{name}}</div>
      <div class="number">编号：{{num}}号 <span>&nbsp;&nbsp;&nbsp;&nbsp;</span><span class="num">能量：{{like}}</span> </div>
      <h2>快来为我点赞、分享助力!</h2>
    <div class="btnbox">
      <div class="btn_sel" @click="vote($event,id)">点赞助力</div>
      <div class="btn_sel" @click="toImage">分享助力</div>
      </div>
      <h3>人物简介：</h3>
      <p class="description">{{desc}}</p>
<!--      <a href="http://pic.dailyqd.com/2021/zmt/index.html" style="display:block;margin-top: 0.6rem;background:#b1855e;border-radius:0.1rem;color:#fff;height:0.9rem;line-height: 0.9rem;">我要参与</a>-->
  </div>
  <div class="poster" ref="imageWrapper">
    <div class="title">{{prize}}</div>
    <div class="imgBox">
      <img :src="imageUrl+'?'+new Date().getTime()" crossOrigin="anonymous" alt="" :class="imgBoxUrl">
      <img src="../../assets/img/imgWrapper.png" alt="" class="imgWrapper">
    </div>
    <div class="title1">我是第五届金海星奖{{category}}</div>
    <div id="qrcode" ref="qrcode" class="qrcode"></div>
    <div class="detail">
      <div>{{ num }}号<span>&nbsp;&nbsp;&nbsp;&nbsp;</span>{{ name }}</div>
      <b>快来为我助力！</b>
      <div class="desc">
        人物简介：
        <div>{{desc | ellipsis}}</div>
      </div>

    </div>
    </div>
  <div class="popUpBox hide"   @click="trugue" @touchmove.prevent>
    <div class="popUp" id="popUp" @touchmove.prevent>
    </div>
    <img :src="imgUrl" alt="" class="posterImage" id="posterImage" @touchmove.prevent>
  </div>

</div>
</template>

<script>
import QRCode from "qrcodejs2";
import html2canvas from "html2canvas";
import { Loading } from 'element-ui';
import $ from 'jquery';
import axios from "axios";
let loading;
const startLoading = ()=>{
  loading = Loading.service({
    lock:true,
    text:'加载中...',
    background:'rgba(255,255,255,0.7)',
  })
}
startLoading();
var time = 0;       //初始时间
var t=0;
export default {
  name: "articleContent",
  data() {
    return {
      imgUrl:'',
      id:0,
      num:'',
      name:'数据加载中请稍后',
      img:'',
      like:'0',
      arr:['优秀自媒体人评选人','优秀自媒体账号候选','优秀自媒体作品候选','优秀自媒体传播案例候选'],
      desc:'数据加载中......',
      category:'',
      ai:'',
      status:'0',
      imageUrl: '', // 跨域地址
      screenshotImage: '',	 // 保存的base64地址,
      imgBoxUrl:' ',
      prize:''
    }
  },
  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 20) {
        return value.slice(0, 20) + "...";
      }
      return value;
    }
  },
  created() {
    var width=parseInt($('.headImg').css('width'));
    var height=parseInt($('.headImg').css('height'));
    if(width>height){
      this.imgBoxUrl='imgBoxUrl imgW'
    }else {
      this.imgBoxUrl='imgBoxUrl imgH'
    }

    this.getData();
  },
  mounted() {
    loading.close();
    var bodyHeight = document.body.scrollHeight ;//获取当前窗口距离页面顶部高度
    console.log(bodyHeight)
    $('.wrapper').css('padding-bottom',bodyHeight*1.8)
    document.getElementById('wrapper').style.cssText += 'paddingBottom:'+ bodyHeight*1.8;
  },
//生成图片
  methods: {
    toImage() {
      var dataURL ='';
      startLoading();
      if(this.status=='1'){

        $('#qrcode').html='';
        let qrcode = new QRCode("qrcode", {
          width: 80, // 二维码宽度，单位像素
          height: 80, // 二维码高度，单位像素
          text: window.location.href // 生成二维码的链接
        });

          html2canvas(this.$refs.imageWrapper,{
            allowTaint: false, ///允许跨域图片
            useCORS: true, //是否尝试使用CORS从服务器加载图像
          }).then(canvas => {
             dataURL = canvas.toDataURL("image/png");
            // this.imgUrl = dataURL;
            if (this.imgUrl !== "") {
              this.dialogTableVisible = true;
            }
          });
        setTimeout(()=>{
          this.imgUrl = dataURL;
          loading.close();
          this.popUp();
          this.$notify({
            title: '长按保存图片，分享朋友圈吧！',
            type: 'success',
          });
        },1000)
      }
    },
    //弹出层
    popUp(){
      $('.popUpBox').removeClass("hide");
      var scrollHeight = $(document).scrollTop();//获取当前窗口距离页面顶部高度
      var windowHeight = $(window).height();//获取当前窗口高度
      var windowWidth = $(window).width();//获取当前窗口宽度
      var popupHeight = $('#posterImage').height();//获取弹出层高度
      var popupWeight = $('#posterImage').width();//获取弹出层宽度
      var posiTop = scrollHeight+(windowHeight-popupHeight)/2;
      var posiLeft = 0;
      $('#posterImage').css({"left": posiLeft + "px","top":posiTop + "px","display":"block"});//设置position
    },
    trugue(){
      $('.popUpBox').addClass("hide");
      $('.qrcode').children().remove();
    },
    getData(n1){
      // 这里使用axios，使用时请提前引入
      var id = this.getID();
      var linkUrl = 'https://www.dailyqd.com/wemedia/api/starfish/honor/'+id;
      axios.get(linkUrl)
        .then(response=>{
          this.category = response.data.data.category;
          this.img = response.data.data.image;
          this.imageUrl = response.data.data.image
          this.name = response.data.data.name;
          this.num = response.data.data.number;
          this.like = response.data.data.like;
          this.desc = response.data.data.description;
          this.id = response.data.data.id;
          this.status ='1';
          this.prize  = response.data.data.prize


        })
        .catch(error=>{
          this.$notify({
            title:'网络异常，请稍后重试',
            type: 'error'
          });
        })
    },
    //获取id
    getID(){
      var url = window.location.href;
      if(url.indexOf("id=") > 0) {
        var id= this.takeParam(url, 'id');
      }
      return id;
    },
    //获取url参数
    takeParam(url,key){
      var a = url ;
      var b= key;
      try {
        var reg=new RegExp( b + "=[0-9a-zA-z-_]{0,}" );
        return reg.exec(a).toString().split("=")[1];
      } catch(e) {
        console.log(e);
        console.log("正则表达式取参数值错误" + key);
      }
      return "";
    },
    vote(event,id){
      // startLoading();
      if (time == 0) {
        time = (new Date()).valueOf();      //初始时间戳
        axios.post('https://www.dailyqd.com/wemedia/api/starfish/vote/'+id)
          //验证通过,投票
          .then(response=>{
            // loading.close();
            if(response.data.code==200){
              let num = $('.num').html();
              let numArr = num.match(/\d+/g);

              numArr = parseInt(numArr) + 1;
              $('.num').html('能量：' + numArr)

              this.$notify({
                title: '能量添加成功',
                type: 'success',
              });
            }else {
              this.$notify({
                title:'能量添加失败',
                type: 'error',
              });
            }
          })
          .catch(error=>{
            loading.close();
            this.$notify({
              title:'您的操作过于频繁，请稍后再试。',
              type: 'error',
            });
          })
      } else {
        var t = Number((new Date()).valueOf()) - Number(time);   //两个时间差值
        if (t <= 300000) {
          this.$notify({
            title: '压力大，5分钟之后再来~',
            type: 'error',
          });
          return;
        } else {
          time = (new Date()).valueOf();    //给time赋值上一次时间戳
          axios.post('https://www.dailyqd.com/wemedia/api/starfish/vote/'+id)
            //验证通过,投票
            .then(response=>{
              // loading.close();
              if(response.data.code==200){
                let num = $('.num').html();
                let numArr = num.match(/\d+/g);

                numArr = parseInt(numArr) + 1;
                $('.num').html('能量：' + numArr)

                this.$notify({
                  title: '能量添加成功',
                  type: 'success',
                });
              }else {
                this.$notify({
                  title:'能量添加失败',
                  type: 'error',
                });
              }
            })
            .catch(error=>{
              loading.close();
              this.$notify({
                title:'您的操作过于频繁，请稍后再试。',
                type: 'error',
              });
            })
        }
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/articleContent.vue